import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
mode: 'history',
  routes: [
    {
      path: '/',
      name: '首页',
      component: resolve => require(['@/components/index'], resolve)
    },
    {
      path: '/top100',
      name: 'APP下载总量TOP100',
      component: resolve => require(['@/components/top100'], resolve)
    },
    {
      path: '/list',
      name: '细分领域榜单排名',
      component: resolve => require(['@/components/list'], resolve)
    },
//  {
//    path: '/company/:id',
//    name: '详情页',
//    component: resolve => require(['@/components/company'], resolve)
//  },
		{
      path: '/grouthRate',
      name: '增长率排名',
      component: resolve => require(['@/components/grouthRate'], resolve)
    },
    {
      path: '/grouthNum',
      name: '增长量排名',
      component: resolve => require(['@/components/grouthNum'], resolve)
    },
    {
      path: '/copyright',
      name: '版权声明',
      component: resolve => require(['@/components/copyright'], resolve)
    },
    {
      path: '/organization',
      name: '发布机构',
      component: resolve => require(['@/components/organization'], resolve)
    },
    {
      path: '/contact',
      name: '联系我们',
      component: resolve => require(['@/components/contact'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js